module.exports = "<nav *ngIf=\"service.Counter > 0\" class=\"navbar fixed-bottom navbar-expand-lg navbar-light bg-secondary text-white\" role=\"navigation\">\n  <div class=\"container\">\n    <a class=\"navbar-brand\">\n      Please wait... {{service.Elapsed}}\n    </a>\n  </div>\n</nav>"


//////////////////
// WEBPACK FOOTER
// D:/OTHERS/FirstmediaShowSchedule/src/app/busy-indicator/busy-indicator.component.html
// module id = ../../../../../src/app/busy-indicator/busy-indicator.component.html
// module chunks = main